/******************************************************************
 * ##: courseProgress
 * Computes a course completion percentage (0-100) from a course
 * record returned by /users/courses. Mirrors the logic previously
 * inlined in CourseCard / CourseDrawer so the home hero and the
 * cards share a single source of truth.
 * @param {Object} course - one course record (with courses_students)
 * @returns {Number} - completion percentage clamped to 0..100
 * History:
 * 05-07-2026: Created
 ******************************************************************/
export const courseProgress = (course) => {
  const lessonStatus = course?.courses_students?.lessonStatus;
  if (!lessonStatus || lessonStatus.length === 0) return 0;

  const completedLessons = lessonStatus.filter((lesson) => lesson.completed === true).length;
  const totalLessons = course?.courses_students?.lessons_count || course?.active_lessons_count;
  const ratio = completedLessons / totalLessons || 0;

  const percentage = Math.round(ratio * 100);
  if (percentage > 100) return 100;
  if (percentage < 0) return 0;
  return percentage;
};

export default courseProgress;
